{
  "intro": "Damit entsteht die erste Administration dieser Installation. Das geht nur einmal.",
  "submit": "Administration anlegen",
  "title": "Erste Administration einrichten",
  "token": "Einrichtungs-Token",
  "tokenHint": "Der Wert von accounts.first_administrator_setup_token in der Serverkonfiguration."
}
